var map = {
	"./briefcase.svg": [
		40363,
		363
	],
	"./calendar.svg": [
		85039
	],
	"./cash.svg": [
		55710,
		5710
	],
	"./charPieSlice.svg": [
		82833,
		2833
	],
	"./clock.svg": [
		62837
	],
	"./diagram.svg": [
		31343
	],
	"./docs.svg": [
		24414,
		4414
	],
	"./gearSix.svg": [
		85169,
		5169
	],
	"./grow.svg": [
		70745,
		745
	],
	"./house.svg": [
		74372
	],
	"./instagram.svg": [
		45918,
		5918
	],
	"./loan.svg": [
		66529,
		6529
	],
	"./office.svg": [
		60706,
		706
	],
	"./percent.svg": [
		12725,
		2725
	],
	"./percentRound.svg": [
		81243,
		1243
	],
	"./prohibit.svg": [
		87959,
		7959
	],
	"./rub.svg": [
		33748
	],
	"./shield.svg": [
		7569
	],
	"./shieldCheck.svg": [
		15303,
		5303
	],
	"./shoppingCart.svg": [
		90002,
		2091
	],
	"./telegram.svg": [
		99554,
		9554
	],
	"./time.svg": [
		91634,
		1634
	],
	"./timer.svg": [
		13268,
		3268
	],
	"./users.svg": [
		85938,
		5938
	],
	"./valt.svg": [
		61163
	],
	"./youtube.svg": [
		68429,
		8429
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 56178;
module.exports = webpackAsyncContext;